// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import i18next from './i18n/config';
import { Provider } from 'react-redux';
import './index.css';
import routes from './routes/AppRoutes';
import store from './store/index';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import ErrorBoundary from './components/error/ErrorBoundary';
import Toaster from './components/dialogbox/Toaster';
import { authActions } from './store/slices/auth';

// Create the router here, not in AppRoutes
const router = createHashRouter(routes);
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

// Cross-tab auth sync via BroadcastChannel
if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
  const authChannel = new BroadcastChannel('auth');
  authChannel.onmessage = (event) => {
    const { type, payload } = event.data || {};
    if (type === 'logout') {
      store.dispatch(authActions.logout());
      if (!location.hash.includes('#/login')) {
        location.hash = '#/login';
      }
    } else if (type === 'setAccount' && payload) {
      store.dispatch(authActions.setAccount(payload));
    }
  };
  window.addEventListener('beforeunload', () => authChannel.close());
}

// Render without StrictMode for production
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <I18nextProvider i18n={i18next}>
        <HelmetProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Toaster />
            <RouterProvider router={router} />
          </ThemeProvider>
        </HelmetProvider>
      </I18nextProvider>
    </Provider>
  </ErrorBoundary>,
);

console.log('Application rendered successfully');
